export const throttle = (delay, cb) => {
    let last;
    let deferTimer;

    return () => {
        let now = +new Date;

        if (last && now < last + delay) {
            clearTimeout(deferTimer);

            deferTimer = setTimeout(() => {
                last = now;
                cb();
            }, delay);
        } else {
            last = now;
            cb();
        }
    };
};
